// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_iGI6w {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  pointer-events: none;
}

.svg_2ghGO {
  pointer-events: none;
}

.svg_2ghGO circle {
  pointer-events: all;
}

.zoomThumb_CC93l {
  stroke: orange;
  stroke-width: 2px;
}

.zoomThumb_CC93l:hover {
  stroke: black;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-video/lib/player/shared/PTZDragTool.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 99999;\n  pointer-events: none;\n}\n\n.svg {\n  pointer-events: none;\n}\n\n.svg circle {\n  pointer-events: all;\n}\n\n.zoomThumb {\n  stroke: orange;\n  stroke-width: 2px;\n}\n\n.zoomThumb:hover {\n  stroke: black;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_iGI6w`,
	"svg": `svg_2ghGO`,
	"zoomThumb": `zoomThumb_CC93l`
};
export default ___CSS_LOADER_EXPORT___;
